/**
 * Avisos flutuantes.
 *
 * Existe uma regra por trás de quando usar isto, e ela importa mais que a
 * biblioteca: **sucesso flutua, erro fica**.
 *
 * Aviso que some sozinho serve para confirmar algo que a pessoa acabou de
 * fazer e já sabe que fez — "perfil salvo", "saque pedido". Ela não
 * precisa reler.
 *
 * Erro é o contrário. "CPF já tem conta", "saldo insuficiente", "esse
 * valor passa do limite" são coisas que a pessoa precisa consultar
 * enquanto corrige o campo. Se o texto sumir em quatro segundos, ela tem
 * de repetir a ação que falhou só para reler o motivo — e num formulário
 * de dinheiro isso é repetir uma tentativa de mover dinheiro.
 *
 * Por isso `avisar.erro` existe mas é para o que não tem lugar na tela:
 * falha de rede, sessão expirada. Erro de validação de campo continua
 * ao lado do campo.
 */
import { toast } from 'sonner';

export const avisar = {
  ok(titulo: string, detalhe?: string): void {
    toast.success(titulo, detalhe ? { description: detalhe } : undefined);
  },

  /**
   * Só para o que não pertence a nenhum campo. Erro de validação fica na
   * tela, junto do que precisa ser corrigido.
   */
  erro(titulo: string, detalhe?: string): void {
    toast.error(titulo, detalhe ? { description: detalhe } : undefined);
  },

  aviso(titulo: string, detalhe?: string): void {
    toast(titulo, detalhe ? { description: detalhe } : undefined);
  },
};
